@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.inputContainer {
  margin: 10px 20px 20px 20px;
  border-radius: 15px;
  border: 1px solid var(--dark-15);
  background: var(--light-100);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);

  [data-autopilot-system-redesign='on'] & {
    box-shadow: none;
    border: 1px solid var(--dark-8);
    margin: 10px 15px 15px 15px;

    &:hover {
      border: 1px solid var(--dark-15);
    }

    &:focus-within {
      border: 1px solid var(--dark-80);
    }
  }
}

.chatInput {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  padding: 12px 8px 12px 12px;
}

.textarea {
  @include sm-sohne;
  @include hide-scrollbar;
  height: 28px;
  width: 100%;
  padding: 0 5px;
  resize: none;
  background: transparent;
  color: var(--dark-80);

  &::placeholder {
    color: var(--dark-60);

    [data-autopilot-system-redesign='on'] & {
      color: var(--dark-40);
    }
  }
}

.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  }
}

.right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.submitButton {
  height: 28px;
  align-self: flex-end;
}

.menu {
  min-width: 196px;
}

.attachButton {
  svg {
    width: 14px !important;
    height: 14px !important;
  }
}

.attachment {
  display: flex;
  position: relative;
  width: fit-content;
}

.thumbnail {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid var(--dark-8);
}

.removeButton {
  position: absolute;
  top: -6px;
  right: -6px;
}
